import Axios from "../../api/Axios";
const BASE_URL = "CreditMReports/";

export const EndpointCreditMReports = {
    GetExcelDataRcptInPrd: "GetExcelDataRcptInPrd",
    GetCustOutExcelData: "GetCustOutExcelData",
    GetParty: "GetParty",
    GetCustExcelData: "GetCustExcelData",
    GetExcelDataDebit: "GetExcelDataDebit",
    GetExcelCreditAdjData: "GetExcelCreditAdjData",
    ledgerReportDownloadData: "ledgerReportDownloadData",
    ledgerReportAccName: "ledgerReportAccName",
    StatementOfAccountsDetailsData: "StatementOfAccountsDetailsData",
    StatementOfAccountsSummaryData: "StatementOfAccountsSummaryData",
    StatementOfAccountsGetSupplier: "StatementOfAccountsGetSupplier",
    StatementOfAccountsGetCustomer: "StatementOfAccountsGetCustomer",
    salesAgeingRptDownload: "salesAgeingRptDownload",
    salesAgeingCustDetailRptDownload: "salesAgeingCustDetailRptDownload",
};

// /api/CreditMReports/GetExcelDataDebit
// GetExcelCreditAdjData
export const createAPIEndpointCreditMReports = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };
};
